<template>
  <div class="retailOrderPay">
    <XR-Result icon="fa fa-yes2" msg="支付成功" content="恭喜您，订单已支付成功" ></XR-Result>
      <mu-dialog  :open="dialog" @close="close" style="padding:0px;">
        <div class="retailOrderPay_Dialog">
          <div class="sharetips">
          <img src="/static/goufre.png" class="img" />
          </div>
          <div style="width:50%;float:left;border-right:1px solid #DEE1E6">
            <mu-flat-button slot="actions" @click="close" label="取消" style="width:100%;"/>
          </div>
          <div style="width:50%;float:left;">
            <mu-flat-button slot="actions" @click="openShareSheet()" label="去分享" style="color:red;width:100%;"/>
          </div>
        </div>
      </mu-dialog>
	  
	  <div v-if="tiglog" class="mu-overlay" style="opacity: 0.4;background-color: rgb(0, 0, 0);position: fixed;z-index: 2014;"></div>
	  <div v-if="tiglog" id="coupon_parent">
	  	  <div id="conpon_child"><img src="/static/coupon/share_tig.png" style="width:60%;height:auto"></div>
	  </div>
	  <div v-if="tiglog" style="position: fixed;display:block;top:30px;right:30px;z-index:99999;width:30vw;">
		<img src="/static/coupon/share_tig2.png" style="width:100%;height:auto">
	  </div>
	  
      <mu-bottom-sheet :open="shareSheet" @close="closeShareSheet">
      <div class="productDetailPage-shareSheetTitle">分享到</div>
      <div class="productDetailPage-shareSheetWayList">
        <div class="shareSheetWayItem" @click="appWeChatFringtShareClick">
          <div class="shareWayIcon wechatFrind"><i class="fa fa-wechat"></i></div>
          <div class="shareWayText">微信好友</div>
        </div>
        <div class="shareSheetWayItem" @click="appWeChatFringtQuanShareClick">          
          <div class="shareWayIcon wechatFrindQuan"><i class="fa fa-diamonds"></i></div>
          <div class="shareWayText">朋友圈</div>
        </div>
      </div>   
    </mu-bottom-sheet>
  </div>
</template>
  
<script>
import appShare from '../../util/appShare' //微信分享
import wechatCache from '../../util/wechatCache'
export default {
  data () {
    return {
    shareUrl:decodeURIComponent(this.$route.query.shareUrl),
    dialog:false,
	tiglog:false,
    shareSheet:false,
    OrderNo:'',
    isApp:false,
	loaded:false
    }
  },  
  created(){
    window.openShare= this.openShare
  },
  mounted(){
	if (this.shareUrl!="undefined" && this.shareUrl!=""){
		setTimeout(() => {
    this.jump()
 
   },3000)   
  }
  this.OrderNo=this.$route.query.OrderNo
  if (!this.closeCoupon){
	this.getUserInfo()
  }
  
  var appClient = window.localStorage.appClient
        if(appClient == 'android' || appClient == 'ios'){
        this.isApp = true
    }
  },
  methods: {
	jump(){
		this.$router.push(this.shareUrl)
  },
  open () {
    this.dialog = true
  },
  close () {
     this.dialog = false
  },
  closeShareSheet () {
    this.shareSheet = false
  },
  openShareSheet () { //APP分享
    if (this.isApp){
      var appClient = window.localStorage.appClient
      if(appClient == 'ios'){      
        //window.webkit.messageHandlers.ajax.postMessage({fun:'share',Ftitle: this.shareTitle,Fimage:this.shareImgUrl ,FjumpUrl: this.shareLinkUrl
		window.webkit.messageHandlers.ajax.postMessage({fun:'shareCallback',Ftitle: this.shareTitle,Fimage:this.shareImgUrl ,FjumpUrl: this.shareLinkUrl,Fjavascript: "AppCallbackUrl('/retail/coupon/shareGetCoupon?OrderNo="+this.OrderNo+"');"})
      }else{
        this.shareSheet = true
      }
    } else {
	  this.close()
	  this.tiglog = true
	}
  },
  openShare(){
	this.shareSheet = true
  },
  closeShare(){
	this.shareSheet = false
  },
  appWeChatFringtShareClick(){
    console.log(this.shareTitle)
    console.log(this.shareDesc)
    console.log(this.shareImgUrl)
    console.log(this.shareLinkUrl)
	
	setTimeout(() => {
		this.closeShare()
		this.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+this.OrderNo) 
	},3000)
	
	appShare.shareWeChatFriend(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
    //appShare.shareWeChatFriendCallback(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl,"javascript:AppCallbackUrl('/retail/coupon/shareGetCoupon?OrderNo="+this.OrderNo+"')")
  },    
  appWeChatFringtQuanShareClick(){
	setTimeout(() => {
		this.closeShare()
		this.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+this.OrderNo) 
	},3000)
	
	appShare.shareWeChatFriendQuan(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
    //appShare.shareWeChatFriendQuanCallback(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl,"javascript:AppCallbackUrl('/retail/coupon/shareGetCoupon?OrderNo="+this.OrderNo+"')")
  },
  getUserInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
         if(res.IsSuccess){
           ths.initWeiXin()
        }else{          
          //ths.$refs.XRtoast.hide()
          ths.loaded= false
        }
      });
    },
  initWeiXin(){
    var ths = this;   
    this.PayCoupon()
    ths.shareTitle = '[转账]请你确认收款'
    ths.shareDesc = '想买东西不花钱，优惠券来帮你忙'
    ths.shareImgUrl = window.location.protocol + '//' + window.location.host + '/static/salesman/tuiguang/share.png'
    // if(ths.productInfo.ImgList && ths.productInfo.ImgList.length>0){
    //   ths.shareImgUrl = ths.productInfo.ImgList[0].ImgPath
    // }
    ths.shareLinkUrl = window.location.protocol + '//' + window.location.host + '/#/retail/coupon/shareGetCoupon?OrderNo='+this.OrderNo
    var openId = wechatCache.getOpenId()
    if(!openId){
	  console.log("未获取微信信息")
      //this.$refs.XRtoast.failed('未获取微信信息', true)
      return
    }
	console.log("已获取微信信息")
    ths.$postBase(
    window.location.protocol + '//' + window.location.host + "/Oauth2/WeChat/wechat.ashx"
    ).then(function(res) {
    if(!res.IsSuccess){
    }else{   
		console.log("成功获取微信参数")
        //ths.$refs.XRtoast.hide()
        ths.loaded = false
		console.log("wx.config2")
		
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.Data.AppId, // 必填，公众号的唯一标识
            timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
            nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
            signature: res.Data.Sign, // 必填，签名，见附录1
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
		console.log("wx.ready")
        wx.ready(function () {	
			console.log("wx.ready微信回调")		
            wx.onMenuShareTimeline({
                title: ths.shareTitle, // 分享标题
                link: ths.shareLinkUrl, // 分享链接
                imgUrl: ths.shareImgUrl, // 分享图标
                success: function () {
				  console.log("朋友圈分享成功")
                  ths.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+ths.OrderNo)
                },
                cancel: function () {
				  console.log("朋友圈分享取消")
                  //ths.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+ths.OrderNo)
                    // 用户取消分享后执行的回调函数
                }
            });
            wx.onMenuShareQQ({
                title: ths.shareTitle, // 分享标题
                desc: ths.shareDesc, // 分享描述
                link: ths.shareLinkUrl, // 分享链接
                imgUrl: ths.shareImgUrl, // 分享图标
                success: function () {
				  console.log("QQ分享成功")
                  ths.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+ths.OrderNo)
                },
                cancel: function () {
				  console.log("QQ分享取消")
                  //ths.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+ths.OrderNo)
                    // 用户取消分享后执行的回调函数
                }
            });
            wx.onMenuShareAppMessage({
                title: ths.shareTitle, // 分享标题
                desc: ths.shareDesc, // 分享描述
                link: ths.shareLinkUrl, // 分享链接
                imgUrl: ths.shareImgUrl, // 分享图标
                success: function () {
				  console.log("微信好友分享成功")
                  ths.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+ths.OrderNo)
                },
                cancel: function () {
				  console.log("微信好友分享取消")
                  //ths.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+ths.OrderNo)
                    // 用户取消分享后执行的回调函数
                }
            });
            wx.onMenuShareQZone({
                title: ths.shareTitle, // 分享标题
                desc: ths.shareDesc, // 分享描述
                link: ths.shareLinkUrl, // 分享链接
                imgUrl: ths.shareImgUrl, // 分享图标
                success: function () {
				  console.log("QQ空间分享成功")
                  ths.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+ths.OrderNo)
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
				  console.log("QQ空间分享取消")
                  //ths.$router.push('/retail/coupon/shareGetCoupon?OrderNo='+ths.OrderNo)
                    // 用户取消分享后执行的回调函数
              }
            });
			
          });
		  console.log("wx.end")
        }
      });
    },
    PayCoupon(){
      var ths=this
      if(ths.OrderNo){
          ths.$post('/Shop/CouponServer/WapIsShare',{OrderNo:ths.OrderNo}).then(function(res){
          if(res.IsSuccess){
            ths.dialog=true
          }else{
            ths.dialog=false
          }
        })
      }
    }
    
  }
}
</script>

<style>
.retailOrderPay_Dialog .mu-dialog-wrapper .mu-dialog-body {padding: 0px;}
.retailOrderPay_Dialog .sharetips{width: 100%; height: 70%;background-color: #F6F6F6;}
.retailOrderPay_Dialog .sharetips .img{width: 100%;height: 100%;}
.retailOrderPay_Dialog .mu-dialog-actions{padding: 5%;}
.retailOrderPay_Dialog .mu-dialog-actions .mu-flat-button{width: 40%;}
.productDetailPage-shareSheetTitle {
  line-height: 40px;
  font-size: 16px;
  padding: 20px 20px 0;
}
.productDetailPage-shareSheetWayList {
  overflow: hidden;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem {
  float: left;
  padding: 20px;
  width: 100px;
  text-align: center;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem .shareWayIcon {
  font-size: 28px;
  border-radius: 50%;
  width:45px;
  height:45px;
  line-height: 45px;
  text-align: center;
  color:white;
  display: inline-block;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrind{
  background: #07BD13;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrindQuan{
  background: #99D021;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem .shareWayText {
  padding-top: 10px;
}

#coupon_parent {
  position: fixed;
  width:100%;
  height: 100%;
  margin: 0;  
  z-index:9999999;
  top:30%;
  text-align:center;
}
#coupon_child {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/pages/retail/orderPaySuccess.vue